/* eslint-disable react/no-multi-comp */
import React from 'react';
import AbstractDriver from './abstractDriver';
import apiDecorator from 'api/api-decorator';
import {routerShape} from "react-router/lib/PropTypes";

@apiDecorator
export default class Domik extends AbstractDriver {
  componentDidMount() {
    this.api.get('billing/internal-pay', {
      queryString: {
        order: this.props.order.hash
      }
    }).then(() => {
      window.location = this.props.waybackUrl;
    });
  }

  render() {
    // const { waybackUrl, order, config, description } = this.props;
    return null;
  }
}

